export { default } from "../.internal/themes/dark";


// WEBPACK FOOTER //
// ../../../src/themes/dark.ts